/* eslint-disable react/prop-types, require-jsdoc */
import React, { Fragment } from 'react';
import styled from 'styled-components';

import Styles from './ParkingForm.Styles';
import ValidateButton from '../TicketsWhite/ValidateButton';
import Text from '../../base/Text';

import { PINK } from '../../../constants/colors';

import TicketInfo from '../TicketInfo';
import InputsField from '../../base/InputsFieldFlat';
import gettingData from '../../../assets/images/clock.gif';
import { getParkingStatus } from '../../../helpers/CartManager';
import purpleArrow from '../../../assets/images/purple_arrow.png';
import mapES from './map/CBX-Mapa-Parking-MAY2023-solo-nombres-ESP.png';
import mapEN from './map/CBX-Mapa-Parking-MAY2023-solo-nombres-ENG.png';

const Column = styled.div`${Styles.column}`;
const Row = styled.div`${Styles.row}`;
const Select = styled.select`${Styles.inputRounderSelect}`;
const InputsWrapper = styled.div`${Styles.inputsWrapper};`;
const LabelInput = styled(Text).attrs({ bold: true })`${Styles.labelInput}`;
const Info = styled(Text).attrs({ bold: true, tag: 'h4' })`${Styles.info}`; // prettier-ignore
const AddPlacesContainer = styled.div`${Styles.addPlacesConatiner}`;
const RounderComponent = styled.div`${Styles.rounderComponent}`;
const Increment = styled.div`${Styles.increment}`;
const Decrement = styled.div`${Styles.increment}`;
const PurplePrice = styled(Text).attrs({ bold: true, tag: 'h4' })`${Styles.purplePrice}`; // prettier-ignore
const PurpleUsd = styled(Text).attrs({ bold: true, tag: 'h4' })`${Styles.purpleUsd}`; // prettier-ignore
const PriceContainer = styled.div`${Styles.priceContainer}`;
const ButtonContainer = styled.div`${Styles.buttonContainer}`;

// eslint-disable-next-line require-jsdoc
const Item = ({
  n, vehicleInfo, onVehicleUpdate, translations
}) => {
  const {
    brand, model, year, color, license, state
  } = vehicleInfo;
  return (
    <div style={{ marginTop: 5 }}>
      <Info className="col-12">{translations.vehicleInformation}</Info>
      <Column style={{ flex: 9 }}>
        <Row style={{ justifyContent: 'flex-start', margin: 0 }}>
          <InputsWrapper style={{ flex: 2 }}>
            <InputsField
              value={brand}
              onChange={e => onVehicleUpdate(n, 'brand', e.target.value)}
              label={translations.maker}
              status={brand ? 1 : 0}
              labelOnTop
            />
          </InputsWrapper>
          <InputsWrapper style={{ flex: 2 }}>
            <InputsField
              value={model}
              onChange={e => onVehicleUpdate(n, 'model', e.target.value)}
              label={translations.model}
              status={model ? 1 : 0}
              labelOnTop
            />
          </InputsWrapper>
          <InputsWrapper style={{ flex: 2 }}>
            <InputsField
              value={year}
              onChange={(e) => {
                if (e.target.value.match(/\D/)) {
                  return;
                }
                onVehicleUpdate(n, 'year', e.target.value);
              }}
              maxLength={4}
              label={translations.year}
              status={year ? 1 : 0}
              labelOnTop
            />
          </InputsWrapper>
        </Row>

        <Row style={{ justifyContent: 'flex-start', margin: '15px 0px' }}>
          <InputsWrapper style={{ flex: 2 }}>
            <InputsField
              value={color}
              onChange={(e) => { onVehicleUpdate(n, 'color', e.target.value); }}
              label={translations.color}
              status={color ? 1 : 0}
              labelOnTop
            />
          </InputsWrapper>
          <InputsWrapper style={{ flex: 2 }}>
            <InputsField
              value={state}
              onChange={(e) => { onVehicleUpdate(n, 'state', e.target.value); }}
              label={translations.state}
              status={state ? 1 : 0}
              labelOnTop
            />
          </InputsWrapper>
          <InputsWrapper style={{ flex: 2 }}>
            <InputsField
              value={license}
              onChange={(e) => { onVehicleUpdate(n, 'license', e.target.value); }}
              label={translations.license}
              status={license ? 1 : 0}
              labelOnTop
            />
          </InputsWrapper>
        </Row>
      </Column>
    </div>);
};

/**
* TicketInfo component
* @returns {JSX.Element}
*/
const ParkingForm = ({
  translations,
  ticketType,
  startDate,
  startDateHandler,
  endDate,
  endDateHandler,
  startTime,
  startTimeHandler,
  endTime,
  endTimeHandler,
  lot,
  locale,
  lotHandler,
  saveParkingInfo,
  increment,
  decrement,
  counterParking,
  initializeCounter,
  onVehicleUpdate,
  callParkingApi,
  getParkingPrice,
  isCallingParkingApi,
  minDate,
  maxDate,
}) => {
  let lotInfo = { price: 0 };
  let cars = [];
  let parkingData = [];
  let parkingLots = [];
  if (typeof window !== 'undefined') {
    parkingData = JSON.parse(window.localStorage.getItem('parking'));
    parkingLots = JSON.parse(window.localStorage.getItem('CBX_Parking_Lots'));
    if (!parkingLots) {
      parkingLots = [];
    }
  }

  const backToHome = () => {
    window.location.href = `/${locale}/`;
  };

  if (parkingData) {
    const { data, vehicles } = parkingData;
    if (data) {
      lotInfo = data;
    }
    if (vehicles) {
      if (vehicles.length > 0) {
        cars = [...vehicles];
        initializeCounter(vehicles.length > counterParking ? vehicles.length : counterParking);
      }
    }
  }

  const generateRows = (counter, vInfo) => {
    const rows = [];
    for (let i = 0; i < counter; i += 1) {
      const vehicleInfo = typeof vInfo[i] !== 'undefined'
        ? vInfo[i]
        : {
          brand: '', model: '', year: '', color: '', license: '', state: ''
        };
      rows.push(
        <Item
          key={i}
          n={i}
          counterParking={counter}
          translations={translations}
          vehicleInfo={vehicleInfo}
          onVehicleUpdate={onVehicleUpdate}
        />
      );
    }
    return rows;
  };

  const validCar = (car) => {
    const minYear = 1900;
    const maxYear = new Date().getFullYear() + 1;
    return !!(car.brand && car.model && (car.year && car.year >= minYear && car.year <= maxYear) && car.color && car.license && car.state);
  };

  const checkVehicles = () => {
    const ValidVehicles = cars
      .map((validCar))
      .filter((isValidCar) => {
        return isValidCar;
      });
    return cars.length > 0 && ValidVehicles.length === counterParking;
  };

  const page = typeof window === 'undefined' ? 'home' : window.location.href.substring(window.location.href.lastIndexOf('/') + 1);

  const freedomPayStyles = {
    borderRadius: '0.25rem',
    borderWidth: '1px',
    borderStyle: 'solid',
    display: 'block',
    fontSize: '1rem',
    fontFamily: 'Arial, sans-serif',
    height: 'calc(2.25rem + 2px)',
    lineHeight: 1.5,
    padding: '0.375rem 0.75rem',
    backgroundColor: 'white',
    marginBottom: '1rem',
    width: '100%',
    outline: 'none',
  };

  return (
    <Fragment>
      <PurpleUsd>
        <img
          alt=""
          width="30px"
          height="20px"
          style={{ marginInline: 'auto', cursor: 'pointer', paddingRight: '10px' }}
          src={purpleArrow}
          locale={locale}
          onClick={backToHome}
        />
        {translations.confirmParkingPage}
      </PurpleUsd>
      <Row>
        <div style={{ display: 'flex', flexDirection: 'column', flex: 3 }}>
          <TicketInfo
            startDate={startDate}
            startDateHandler={startDateHandler}
            endDate={endDate}
            endDateHandler={endDateHandler}
            startTime={startTime}
            startTimeHandler={startTimeHandler}
            endTime={endTime}
            endTimeHanlder={endTimeHandler}
            lot={lot}
            locale={locale}
            lotHandler={lotHandler}
            ticketType={ticketType}
            selectorItem="Parking"
            translations={translations}
            minDate={minDate}
            maxDate={maxDate}
            callParkingApi={callParkingApi}
            getParkingPrice={getParkingPrice}
            page={page}
          />
          <InputsWrapper style={{ flex: 2, marginTop: '10px' }}>
            <LabelInput>{locale === 'es' ? 'Seleccionar lote' : 'Select lot'}</LabelInput>
            <Select
              value={lot}
              onChange={lotHandler}
              style={page !== 'home' ? freedomPayStyles : {}}
            >
              <option value="" key="empty" selected>{ getParkingStatus && (locale === 'es' ? 'Seleccionar lote' : 'Select lot')}</option>
              {parkingLots.map(i => (
                <option key={i.id} value={i.id}>{i.location_name}</option>
              ))}
            </Select>
          </InputsWrapper>
          {parkingData && parkingData.data && !isCallingParkingApi && parkingData.data.spots <= 0 && (
            <div
              style={{
                padding: '5%',
                width: '100%',
                margin: 'auto',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <Info>{locale === 'es' ? ['Las reservaciones para el estacionamiento están agotadas para la selección de lote y fecha. Te sugerimos verificar la disponibilidad en otro lote.' , <br/>, 'Consejo: Siempre tenemos disponibilidad para reservas de valet. También ofrecemos una variedad de opciones de estacionamiento de último minuto y servicios de valet en sitio.'] : ['Reservations are fully booked for lot and date selection. Please check another lot for availability.', <br/>, 'Tip: Valet Reservations are always available and we also offer plenty of last minute self-parking options and valet services on site.']}</Info>
            </div>
          )}
          {parkingData && parkingData.data && !isCallingParkingApi && parkingData.data.spots > 0 && startDate && endDate && startTime && endTime && lot && (
            <Fragment>
              {generateRows(counterParking, cars)}
              <AddPlacesContainer>
                <Info className="col-12" style={{ width: '150px' }}>{translations.addRemovePlaces}</Info>
                <RounderComponent>
                  <Decrement onClick={decrement}>
                    <Info>-</Info>
                  </Decrement>
                  <h3 style={{ color: PINK }} id="c">{counterParking}</h3>
                  <Increment
                    style={{ marginLeft: '8px' }}
                    onClick={increment}
                  >
                    <Info>+</Info>
                  </Increment>
                </RounderComponent>
              </AddPlacesContainer>
              <PriceContainer>
                <PurpleUsd>Total:</PurpleUsd>
                <div style={{ display: 'flex' }}><PurplePrice>{`$${lotInfo.price > 0 ? (lotInfo.price.toFixed(2) * counterParking).toFixed(2) : 0}`}</PurplePrice><PurpleUsd>USD</PurpleUsd></div>
                <Row>
                  <ButtonContainer>
                    <ValidateButton
                      disabled={!startDate || !endDate || !startTime || !endTime || !checkVehicles()}
                      action={saveParkingInfo}
                      message={translations.continueLabel}
                    />
                  </ButtonContainer>
                </Row>
              </PriceContainer>
            </Fragment>
          )}
          {isCallingParkingApi && (
            <div
              style={{
                padding: '5%',
                width: '100%',
                margin: 'auto',
                justifyContent: 'center'
              }}
            >
              <img
                alt=""
                style={{ margin: 'auto', display: 'block ' }}
                width="150px"
                height="auto"
                src={gettingData}
              />
            </div>
          )}
        </div>
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flex: 2
        }}
        >
          <img
            alt=""
            style={{ margin: 'auto', display: 'block ', padding: '20px' }}
            width="400px"
            height="auto"
            src={`https://cbx-fe.s3.us-east-2.amazonaws.com/app/cbx-map-app-${locale === 'en' ? 'eng' : 'esp'}.png`}
          />
        </div>
      </Row>
    </Fragment>
  );
};


export default ParkingForm;
